import { shape, number, object, bool, string, instanceOf, oneOfType, arrayOf } from "prop-types"

export const advertiserShape = shape ({
    advertiser_id: oneOfType([number, string]),
    masterCalendar: instanceOf(object),
    isCompare: bool,
    typeSelect: string,
    google_analytics_id: number,
    advertiser_name: string,
    data_collected_date: string,
    google_analytics_property_id: string,
})

export const datePropsType = oneOfType(string, instanceOf(Date));

export const rangePropsType = shape({
    start: datePropsType,
    end: datePropsType
});

export const radioOptionsPropsType = arrayOf(
  shape({
    name: string.isRequired,
    value: oneOfType([bool, number, string]).isRequired,
  })
);

export const baseSelectorShape = shape({
  label: string,
  labelKey: string,
  valueKey: string,
});

export const industryShape = shape({
  industryId: oneOfType([string, number]),
  industryName: string,
  category: shape({
    categoryId: string,
    categoryName: string,
  }),
})
